import { render, staticRenderFns } from "./SetAvatarModal.vue?vue&type=template&id=6f9e490a&scoped=true"
import script from "./SetAvatarModal.vue?vue&type=script&lang=js"
export * from "./SetAvatarModal.vue?vue&type=script&lang=js"
import style0 from "./SetAvatarModal.vue?vue&type=style&index=0&id=6f9e490a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9e490a",
  null
  
)

export default component.exports